// extracted by mini-css-extract-plugin
export var animationContainer = "_gu-0";
export var asteriskIcon = "_gu-8";
export var conversationLeftSection = "_gu-4";
export var conversationListItem = "_gu-3";
export var conversationMiddleSection = "_gu-5";
export var conversationRightSection = "_gu-6";
export var detailsContent = "_gu-1";
export var listContainer = "_gu-7";
export var modalContent = "_gu-2";